import * as React from 'react';
import { connect } from 'react-redux';
import { fetchExportarSellersApi } from '../../../api/axios';
import { Spinner } from 'react-bootstrap';
import ReactExport from "react-export-excel";
import { toast } from 'react-toastify';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


class ExportarSellers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datosExcelFormateados: null,
      hideSpinner: true
    }
  }

  busquedaParaDescargarExcel = () => {

    this.setState({ hideSpinner: false });
    this.requestParaExportar({});
  }

  requestParaExportar = async (request) => {
          
    let req = null;
    try {
      req = await fetchExportarSellersApi(request);
    } catch (e) {
      toast.error('No se pudieron descargar los sellers');
      return
    }

    this.ordenarExcel(req.sellers);
  }

  ordenarExcel = (sellers) => {

    let listaSellers = [];

    sellers.map((item => {

      let datoSeller = {
        codigo: item.codigo == null ? "" : item.codigo,
        razonSocial: item.razonSocial,
        domicilio: item.domicilio,
        numeroDomicilio: item.numeroDomicilio == null ? "" : item.numeroDomicilio,
        localidad: item.localidad,
        provincia: item.provincia,
        codigoPostal: item.codigoPostal,
        telefono: item.telefono,
        cuit: item.cuit,
        email: item.email,
        emailDespacho: item.emailDespacho,
        urlPushOrdenes: item.urlPushOrdenes,
        estado: item.estado,
        sufijo: item.sufijo,
        idEmpresaEnviopack: item.idEmpresaEnviopack == 0 ? "" : item.idEmpresaEnviopack,
        modalidadEPK: item.modalidadEPK == null ? "" : item.modalidadEPK,
        diasCorte: item.diasCorte == null ? "" : item.diasCorte,
        diasPlazoPago: item.diasPlazoPago == null ? "" : item.diasPlazoPago,
        nombreTienda: item.nombreTienda == null ? "" : item.nombreTienda,
        logo: item.logo == null ? "" : item.logo,
        tiendaActiva: item.tiendaActiva == true ? 'Activa' : 'Inactiva'
      };

      listaSellers.push(datoSeller);
    }))

    this.setState({
      datosExcelFormateados: listaSellers,
      hideSpinner: true,
    })

    document.getElementById("btnDescargaExcel").click();
  }


  render() {

    let sizeArray = JSON.stringify(this.state.datosExcelFormateados);

    return (
      
      <div>
        <div className="row page-titles">

          <div className="col-md-8 align-self-center">
            <h4 className="text-themecolor color-rojo-megatone">Sellers</h4>
          </div>

          <div className="col-md-2 button-group align-self-center text-right d-none d-md-block">
            <Spinner hidden={ this.state.hideSpinner || sizeArray == "[]" } animation="border" variant="secondary" size="sm-centrado" role="status" className="excel-spinner">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>

          <div className="col-md-2 button-group align-self-center text-right d-none d-md-block">
              
              <button 
                type="button" 
                onClick={this.busquedaParaDescargarExcel} 
                className="btn btn-sm btn-green" 
                disabled={false}
              >
                Descargar sellers
              </button>

            <ExcelFile 
              filename="Sellers" 
              element={<button id="btnDescargaExcel" type="button" hidden={true}/>}
            >
              <ExcelSheet data={this.state.datosExcelFormateados} name="Publicaciones">
                <ExcelColumn label="Código" value="codigo"/>
                <ExcelColumn label="Razón Social" value="razonSocial"/>
                <ExcelColumn label="Domicilio" value="domicilio"/>
                <ExcelColumn label="Domicilio Numero" value="numeroDomicilio"/>
                <ExcelColumn label="Localidad" value="localidad"/>
                <ExcelColumn label="Provincia" value="provincia"/>
                <ExcelColumn label="Código Postal" value="codigoPostal"/>
                <ExcelColumn label="Teléfono" value="telefono"/>
                <ExcelColumn label="CUIT" value="cuit"/>
                <ExcelColumn label="E-mail" value="email"/>
                <ExcelColumn label="E-mail Despacho" value="emailDespacho"/>
                <ExcelColumn label="URL Push Ordenes" value="urlPushOrdenes"/>
                <ExcelColumn label="Estado" value="estado"/>
                <ExcelColumn label="Sufijo" value="sufijo"/>
                <ExcelColumn label="ID Empresa Enviopack" value="idEmpresaEnviopack"/>
                <ExcelColumn label="Modalidad EPK" value="modalidadEPK"/>
                <ExcelColumn label="Días De Corte" value="diasCorte"/>
                <ExcelColumn label="Días Plazo De Pago" value="diasPlazoPago"/>
                <ExcelColumn label="Nombre Tienda" value="nombreTienda"/>
                <ExcelColumn label="Logo" value="logo"/>
                <ExcelColumn label="Estado Tienda" value="tiendaActiva"/>
              </ExcelSheet>
            </ExcelFile>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  tipoUsuario: state.general.tipoUsuario,
  idSeller: state.general.idSeller,
});

export default connect(mapStateToProps, {})(ExportarSellers);